/**
 * `@visx/vendor/d3-time` (CommonJS)
 * See upstream license: https://github.com/d3/d3-time/blob/main/LICENSE
 *
 * This CJS package exports transpiled vendor files in `vendor-cjs/d3-time`
 */
module.exports = require('../vendor-cjs/d3-time/src/index.js');